import { render, staticRenderFns } from "./EmptyView.vue?vue&type=template&id=7954e9c2&scoped=true&lang=pug"
import script from "./EmptyView.vue?vue&type=script&lang=js"
export * from "./EmptyView.vue?vue&type=script&lang=js"
import style0 from "./EmptyView.vue?vue&type=style&index=0&id=7954e9c2&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7954e9c2",
  null
  
)

export default component.exports